import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { forceLogout, isTokenExpired } from '../apis/axiosConfig';

const PrivateRouter = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const user = localStorage.getItem('user');
  const valid = Boolean((token || user) && !isTokenExpired(token));

  useEffect(() => {
    // 1. Initial check on mount
    const currentToken = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!currentToken || isTokenExpired(currentToken)) {
      forceLogout();
    }

    // 2. Periodic background check every 3 seconds for instant auto-logout
    const interval = setInterval(() => {
      const liveToken = localStorage.getItem('token') || sessionStorage.getItem('token');
      if (!liveToken || isTokenExpired(liveToken)) {
        forceLogout();
      }
    }, 3000);

    // 3. Multi-tab synchronization (logout across all tabs simultaneously)
    const handleStorageChange = (e) => {
      if (e.key === 'token' && (!e.newValue || isTokenExpired(e.newValue))) {
        forceLogout();
      }
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  if (!valid) {
    return <Navigate to="/signin" replace />;
  }

  return <Outlet />;
};

export default PrivateRouter;
